import { render } from "./AllTestConfig.vue?vue&type=template&id=49352ca0"
import script from "./AllTestConfig.vue?vue&type=script&lang=js"
export * from "./AllTestConfig.vue?vue&type=script&lang=js"

import "./AllTestConfig.vue?vue&type=style&index=0&id=49352ca0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__